'use client';
import useV2Position from '@/application/read/migrate/useV2Position';
import useAddress from '@/application/read/web3/useAddress';
import MigrateLiquidity from '../MigrateLiquidity';
import MigrateLoading from './MigrateLoading';
import MigrateInventory from '../MigrateInventory';
import Button from '../../elements/Button';
import { normalizeChainSlug } from '@/domain/network';
import { useNetwork } from '@/presentation/context/network';

export type Props = {
  positionId: string;
};

const MigrateContainer = ({ positionId }: { positionId: string }) => {
  const { network } = useNetwork();
  const userAddress = useAddress();
  const { data: position, status } = useV2Position({ positionId, userAddress });

  if (status === 'success' && !position) {
    return (
      <div className="text-center p-4 rounded-lg border border-gray-300 bg-gray-50 space-y-4">
        <p className="text-xl">{'No position found'}</p>
        <Button
          href={`/${normalizeChainSlug(network)}/profile/migrate`}
          className="inline-flex"
        >
          {'Go back'}
        </Button>
      </div>
    );
  }

  if (!position) {
    return <MigrateLoading />;
  }

  if (position.type === 'xSlp' || position.type === 'slp') {
    return <MigrateLiquidity position={position} />;
  }
  if (position.type === 'vToken' || position.type === 'xToken') {
    return <MigrateInventory position={position} />;
  }

  return <div>{`Migrate ${position.type} is not supported yet.`}</div>;
};

export default MigrateContainer;
